export var getXPath = function (_element) {
    if (!_element)
        return null;
    try {
        var element_1 = _element;
        // Recursively build the XPath by traversing up the DOM
        var parts = [];
        while (element_1 && element_1.nodeType === Node.ELEMENT_NODE) {
            var part = element_1.nodeName.toLowerCase(); // Use tag name
            // Add element's class, if available
            if (element_1.className) {
                var classes = element_1.className.trim().replace(/\s+/g, ' ');
                part += "[@class=\"".concat(classes, "\"]");
            }
            // If the element has siblings with the same tag name, add an index
            var siblings = Array.from(element_1.parentNode ? element_1.parentNode.children : []);
            var sameTagSiblings = siblings.filter(function (sib) { return sib.nodeName === element_1.nodeName; });
            if (sameTagSiblings.length > 1) {
                var index = sameTagSiblings.indexOf(element_1) + 1;
                part += "[".concat(index, "]"); // Add 1-based index in brackets
            }
            parts.unshift(part); // Add to the beginning of the array
            element_1 = element_1.parentNode; // Move up to the parent
        }
        return '/' + parts.join('/');
    }
    catch (_) {
        return null;
    }
};
